<template>
  <div>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("routes.edit_supporter") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
    </v-toolbar>

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <!-- <v-tabs v-model="tab">
              <v-tab>{{ $t("labels.en") }}</v-tab>
              <v-tab>{{ $t("labels.ar") }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <supporter-form :isUpdate="true" locale="en"></supporter-form>
              </v-tab-item>
              <v-tab-item>
                <supporter-form :isUpdate="true" locale="ar"></supporter-form>
              </v-tab-item>
            </v-tabs-items> -->
            <div>
              <v-spacer></v-spacer>
              <locale-select @change="fireLocaleChange" />
            </div>

            <supporter-form :isUpdate="true" :locale="locale"></supporter-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- <supporter-form :isUpdate="true"></supporter-form> -->
  </div>
</template>

<script>
import SupporterForm from "./components/SupportersForm";
import Cookies from "js-cookie";

export default {
  name: "EditSupporter",
  components: {
    SupporterForm
  },
  data() {
    return {
      locale: Cookies.get("language")
    };
  },
  methods: {
    fireLocaleChange(value) {
      this.locale = value;
    }
  }
};
</script>

<style lang="scss" scoped></style>
